import React, { useEffect, useState, useMemo } from 'react';
import { appInfo } from '@/src/pages/customer_service/lib/get-enviroment';
import clsx from 'clsx';
import i18nClient from '../../locales/i18n.config';
import { onFaqClick, openDirectUrl, reportWarn } from '../../utils';
import OrderItem from '../OrderItem';
import BottomDialog from '../BottomDialog';
import { lxClickReport, lxViewReport } from '../../lib/lx';
import { CustomerCid } from '../../contant';
import { OrderHelperBidMvType, OrderHelperBidMcType } from '../../lib/constant';
import './index.css';

const Statistics = Mach.requireModule('Statistics');
const SLCommon = Mach.requireModule('SLCommon');

export default function Index(props: any) {
  const {
    orderHelperList,
    title, rightBtn, rightBtnTxt, orderDTO, hasDetail, onSwitchOrder, orderHelperScene = 1, from, visitId, bizline
  } = props;
  const [phoneList, setPhoneList] = useState<any>([]);
  const [showPhoneSelect, setShowPhoneSelect] = useState<boolean>(false);

  const openPhoneDialog = (number: string | number) => {
    // Statistics.click(JudasConstant.CID, JudasConstant.SHOP_DETAIL_PHONE_LIST_CLICK, { shop_id: this.shopInfo.shopId });
    SLCommon?.callPhone?.({
      content: number,
    });
  };

  const orderHelperPVType = useMemo(() => ({
    1: CustomerCid.HomePage,
    2: CustomerCid.OrderPage
  }), []);

  useEffect(() => {
    orderHelperList?.forEach((button: any, index: number) => {
      const { name, button: { type = '' } = {} } = button || {};
      lxViewReport(orderHelperPVType[orderHelperScene], OrderHelperBidMvType[orderHelperScene], {
        event_name: '订单助手-按钮曝光',
        button_name: name,
        type,
        index,
        bizline,
        from,
        visitId,
      });
    });
  }, [bizline, from, orderHelperList, orderHelperPVType, orderHelperScene, visitId]);

  const handleClick = (data: any, index) => {
    const { button } = data;
    if (!button) {
      return;
    }
    lxClickReport(orderHelperPVType[orderHelperScene], OrderHelperBidMcType[orderHelperScene], {
      event_name: '订单助手-按钮点击',
      button_name: data?.name,
      type: button?.type,
      index,
      from,
      visitId,
      bizline,
    });
    switch (button.type) {
      case 'phone': {
        if (!button.phoneNum) return;
        if (typeof button.phoneNum === 'string') {
          const tempArr = button.phoneNum.split(',');
          if (tempArr.length > 1) {
            const newphoneList = [
              ...tempArr.map((str) => ({
                name: str,
              })),
            ];
            setPhoneList(newphoneList);
            setShowPhoneSelect(true);
          } else {
            openPhoneDialog(button.phoneNum);
          }
          return;
        }
        if (Array.isArray(button.phoneNum)) {
          let resArr: Array<any> = [];
          button.phoneNum.forEach((item) => {
            const tempArr = item.split(',');
            resArr = [
              ...resArr,
              ...tempArr.map((str) => ({
                name: str,
              })),
            ];
          });
          if (resArr.length > 1) {
            setPhoneList([...resArr]);
            setShowPhoneSelect(true);
          } else if (resArr.length === 1) {
            openPhoneDialog(resArr?.[0]?.name);
          }
        }
        break;
      }
      case 'redirect': {
        openDirectUrl(button);
        break;
      }
      case 'faq': {
        if (!button.faqDTO) return;
        if (!from) reportWarn('Card handleClick 缺少from');
        onFaqClick(button.faqDTO, from, true, orderDTO?.orderId);
        break;
      }
      default:
    }
    // 埋点事件
    // this.lxReportMC(button, index);
  };
  return (
    <view className={clsx(orderHelperScene === '2' ? 'helper-card-in-order' : 'helper-card')}>
      {orderHelperScene === '2' ? null : (
        <view className="helper-card-title">
          <text className="helper-card-left-title">{title}</text>
          {rightBtn && (
            <text className="helper-card-right-title" onClick={onSwitchOrder}>
              {rightBtnTxt}
            </text>
          )}
        </view>
      )}

      <view className="helper-card-container">
        {hasDetail && (
          <view className="order-item-wrapper">
            <OrderItem order={orderDTO} hiddenIcon visitId={visitId} from={from} />
          </view>
        )}
        {
          !!orderHelperList?.length && (
            <view className="helper-card-btns-box">
              {orderHelperList?.map((item, index) => (
                <view
                  key={index}
                  className="helper-card-btn"
                  style={{ marginTop: index > 3 ? 10 : 0 }}
                  onClick={() => handleClick(item, index)}
                >
                  <image className="helper-card-btn-logo" src={appInfo.isrtl ? item.rtlIconUrl : item.iconUrl} />
                  <text className="helper-card-btn-text">{item.name}</text>
                </view>
              ))}
            </view>
          )
        }
      </view>
      <BottomDialog
        visible={showPhoneSelect}
        btnText={i18nClient.getText('cs_portal_cancel') || '取消'}
        onMaskClick={() => setShowPhoneSelect(false)}
        onOK={() => setShowPhoneSelect(false)}
        content={(
          <view className={clsx('cs-phone-content', Mach.env.isIOS && 'cs-phone-ios')}>
            {phoneList?.map((item, index) => (
              <view key={index} onClick={() => openPhoneDialog(item.name)}>
                <text
                  style={{ fontSize: 18 }}
                  key={item.name}
                  className={clsx('cs-phone-item', index === phoneList.length - 1 && 'cs-phone-item-last')}
                >
                  {item.name}
                </text>
              </view>
            ))}
          </view>
        )}
      />
    </view>
  );
}
